// extracted by mini-css-extract-plugin
export default {"btn__send":"PasswordRecovery_btn__send__8LmX7","card__footer__link":"PasswordRecovery_card__footer__link__mVOxB"};